<template>
  <div class="wrapper">
    <div class="header-wrapper">
      <div class="header">积分管理</div>
      <div class="addManager">
        <Button class="bkcc-btn" @click="exportFile">导出</Button>
        <Button class="bkcc-btn" @click="loadData">搜索</Button>
        <Button class="bkcc-btn" @click="searchReset">重置</Button>
      </div>
    </div>
    
    <div class="content">
      <Card>
        <i-form ref="searchForm" :model="query">
          <row :gutter="20">
            <i-col span="6">
              <form-item label="姓名">
                <i-input
                  v-model="query.username"
                  clearable
                  placeholder="请填写姓名"
                />
              </form-item>
            </i-col>
             <i-col span="6">
              <form-item label="社区" prop="community">
                <Cascader
                  v-model="comList"
                  :data="communityList"
                  placeholder="请选择"
                  clearable
                  change-on-select
                ></Cascader>
              </form-item>
            </i-col>
          </row>
        </i-form>
      </Card>
      <Card class="card" style="margin-top: 20px">
        <Table border :columns="columns" :data="data" :loading="loading"></Table>
        <div class="page">
          <Page :total="total" :current="pageNum" @on-page-size-change="changePageSize" show-total :page-size="pageSize" :page-size-opts="[10,15,20,50,100,200]" @on-change="page" show-sizer/>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import { Page } from "view-design";
const querystring = require("querystring");
export default {
  components:{
    Page
  },
  data() {
    return {
      comList: [],
      query: {
        username: "",
        communityId:""
      },
      columns: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center"
        },
        {
          title: "姓名",
          key: "username",
          align: "center"
        },
        {
          title: "社区",
          key: "communityName",
          align: "center"
        },
        {
          title: "积分",
          key: "score",
          align: "center"
        },
       
      ],
      pageNum: 1,
      pageSize: 10,
      communityList: [],
      data:[],
      loading: true,
      total: 0,
    };
  },
  computed: {
    
  },
  methods: {
    
    getCommunity() {
      this.$get(this.urlobj.getCommunityCascade, {
        communityId: this.$store.state.streetorcommunityid,
        nationwide: 1,
      })
      .then((res) => {
        this.communityList = res.rows.length
          ? this.formateData(res.rows)
          : [];
      })
      .catch((e) => {
        this.$Message.error("获取行政区域失败");
      });
    },

    //处理行政区域数据
    formateData(data){
      let returnData = data.map(item => {
          return {
              value:item.communityId,
              label:item.communityName,
              children:item.children.length?this.formateData(item.children):[]
          }
      })
      return returnData;
    },

    async exportFile(){
      let url = this.urlobj.getScoreExcel
      console.log(`${url}?${querystring.stringify(this.query)}&token=${this.$store.state.access_token}&appType=${this.$store.state.apptype}`);
      
       try {
        const exportConfigs = [
          {
            url: `${url}?${querystring.stringify(this.query)}&token=${this.$store.state.access_token}&appType=${this.$store.state.apptype}`,
            name: '东乡积分管理接口.xlsx'
          },
        ];
        
        // 顺序下载
        for (const config of exportConfigs) {
          await this.downloadFileWithName(config.url, config.name);
        }
        
        this.$Message.success('文件导出成功！');
      } catch (error) {
        console.error('导出失败:', error);
        this.$Message.error('文件导出失败！');
      }
    },
    downloadFileWithName(url, fileName) {
      return new Promise((resolve, reject) => {
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.style.display = 'none';
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        setTimeout(resolve, 500); // 添加延迟确保下载开始
      });
    },
    
    searchReset(){
      this.pageNum = 1
      this.pageSize = 10
      this.$refs.searchForm.resetFields();
      this.comList = []
      this.loadData();
    },
    loadData(){
      this.loading = true

      if (this.comList && this.comList.length > 0) {
        this.query.communityId = this.comList[this.comList.length-1]
      }

      let url = this.urlobj.getScoreCount;
      var data = { 
        appType:this.$store.state.apptype,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ...this.query
      };
      this.$post(url,data)
      .then(res => {
        this.data = res.rows.map(item => {
          return {
            ...item,
            score: item.score >= 100 ? (item.score / 100) : item.score,
          }
        })
        this.total = res.total
        if (!res.isSucceed) {
          this.$Modal.confirm({
            title: "提示",
            content: res.message
          });
        }
        this.loading=false
      })
      .catch(e => {
        console.error(e)
        this.loading=false
      })
    },

    changePageSize(val){
      this.pageSize = val
      this.loadData()
    },
    page(val) {
      this.pageNum = val;
      this.loadData()
    },
    
  },
  mounted() {
    this.loadData()
  },
  created() {
    this.getCommunity();
  }
};
</script>
<style lang='less' scoped>
.wrapper {
  color: #666666;
  height: 100%;
}

.wrapper::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  /* height: 4px; */
}
.header-wrapper {
  display: flex;
  justify-content: center;
  height: 84px;
  line-height: 84px;
  position: relative;
}
.header {
  font-size: 25px;
  text-align: center;
}
.addManager {
  position: absolute;
  right: 20px;
}
.content {
  //   @content();
  // max-width: 96%;
  margin: 20px;
  margin-top: 0;
  // background: #fff;
  // padding: 0 15px 0 15px;
  &::-webkit-scrollbar {
    display: none;
  }
  .select-wrapper {
    font-size: 16px;
    margin-bottom: 20px;
    .name {
      margin-bottom: 10px;
    }
    .input {
      width: 30%;
    }
  }
  .card {
    height: 100%;
  }
  /deep/ .ivu-table-overflowX {
    overflow-x: hidden !important;
  }
}
.search {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
}
.table-tabs {
  max-width: 100%;
  padding: 0;
  margin-top: 30px;

  /deep/ .ivu-tabs-bar {
    margin-bottom: 0;
    border-bottom: 0;
  }
  /deep/ .ivu-tabs-tab-active {
    color: white;
    background: #fe7d43;
    border-radius: 5px 5px 0 0;
  }
  /deep/ .ivu-tabs-ink-bar {
    height: 0px;
  }
  /deep/ .ivu-tabs-nav {
    padding-left: 10px;
    color: black;
  }
}

.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  min-height: calc(100vh - 450px);
}
.page {
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
.code-img {
  margin: 20px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  // width: 172px;
  height: 172px;
  img {
    width: 172px;
    height: 172px;
  }
}
.text {
  font-size: 16px;
  span {
    text-decoration: underline;
    color: #fe7d43;
  }
}
/deep/ .ivu-table-tip table td{
  width: 100% !important;
}
/deep/ th .ivu-table-cell span {
  font-weight: bold !important;
}
</style>